export default __webpack_public_path__ + "static/media/Snd_LowerGHelicopter.ea8da8df.mp3";